<template>
  <div class="main">
    <Breadcrumb :options="breadcrumb" />

    <RadioGroup :options="radioData" @radioChange="radioChange" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #end>
        <el-form-item>
          <el-button type="success" @click="settle">结算</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :btns="btns" :showSelect="true"
      :showTotal="true" :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template #edittime="params">
        {{ params.params.edittime ? params.params.edittime.slice(0, 10) : "-" }}
      </template>
      <template #open="params">
        <MySwitch :data="params.params" :activeValue="'2'" :inactiveValue="'1'" @onToggle="toggleDisplay"></MySwitch>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'order',
      getListUrl: 'shipperrec',
      breadcrumb: [
        { name: "财务管理", path: `/finance/shipper` },
        { name: "应收账款管理", path: `/finance/shipper` },
        { name: "订单列表" },
      ],
      radioData: [
        { label: "全部订单", value: 1 },
        { label: "普通订单", value: 3 },
        { label: "合同订单", value: 2 },
      ],
      formInline: {
        index: 1,
      },
      formCtrl: [
        {
          ...this.ctrls.fleet,
          options: [],
        },
        // {
        //   ...this.ctrls.date,
        //   label: "装货日期",
        //   keyName: "starttime",
        // },
        {
          ...this.ctrls.date,
          label: "卸货日期",
          keyName: "edittime",
        },
        // {
        //   label: "装货地址：",
        //   keyName: "coaddress",
        //   placeholder: "请填写装货地址",
        //   type: "text",
        // },
        // {
        //   label: "卸货地址：",
        //   keyName: "enaddress",
        //   placeholder: "请填写卸货地址",
        //   type: "text",
        // },
        // {
        //   label: "公司单价：",
        //   keyName: "cprice",
        //   placeholder: "请填写公司单价",
        //   type: "text",
        // },
        {
          ...this.ctrls.license,
          label: "车牌号",
        },
        {
          label: "结算",
          keyName: "settled",
          placeholder: "请选择",
          type: "select",
          options: [
            { label: '未结算', value: 1 },
            { label: '已结算', value: 2 },
          ],
        },
      ],
      cols: [
        { prop: "order_num", label: "订单编号", width: 120 },
        { prop: "license", label: "车牌号", width: 120 },
        { prop: "shname", label: "客户名称" },
        { prop: "coaddress", label: "装货地址", width: 150 },
        { prop: "enaddress", label: "卸货地址", width: 150 },
        { prop: "edittime", label: "卸货日期", width: 100, slot: "edittime" },
        { prop: "inton", label: "装货重量", align: 'right', className: 'pr30', width: 120 },
        { prop: "unton", label: "卸货重量", align: 'right', className: 'pr30', width: 120 },
        { prop: "ceton", label: "亏吨重量", align: 'right', className: 'pr30', width: 120 },
        { prop: "untons", label: "公司承担亏吨", align: 'right', className: 'pr30', width: 140 },
        { prop: "dtonprice", label: "亏吨单价", align: 'right', className: 'pr30', width: 120 },
        { prop: "untonmoney", label: "亏吨金额", align: 'right', className: 'pr30', width: 120 },
        { prop: "message", label: "信息费", align: 'right', className: 'pr30', width: 110 },
        { prop: "cprice", label: "公司单价", align: 'right', className: 'pr30', width: 120 },
        { prop: "dprice", label: "司机单价", align: 'right', className: 'pr30', width: 120 },
        { prop: "freight", label: "公司运费", align: 'right', className: 'pr30', width: 120 },
        { prop: "infreight", label: "司机运费", align: 'right', className: 'pr30', width: 120 },
        { prop: "compen", label: "订单补差", align: 'right', className: 'pr30', width: 120 },
        { prop: "open", label: "结算", slot: "open" },
        { prop: "repaytime", label: "预计结款日期", width: 120 },
      ],
      getTotalProperty: ['inton', 'unton', "ceton", "untons", "untonmoney", "message", "infreight", "freight", 'compen'],
      baseParams: ['index', 'shipperid'],
    };
  },
  methods: {
    setFleet({ team }) {
      this.formCtrl.map(c => {
        if (c.keyName == 'fleet') {
          c.options = team.map(v => {
            return {
              label: v.nickname,
              value: v.id,
            }
          })
          c.options.push({
            label: '雇佣订单',
            value: 10000,
          })
        }
      })
      this.$forceUpdate()
    },
    radioChange(v) {
      // console.log(v);
      this.formInline.index = v
      this.getList();
    },
    tableDataHandler({ count, data }) {
      this.total = count
      if (data && data.length) {
        this.tableData = data.map(v => {
          const obj = this.dataObjHandler(v)
          obj.open = v.settled + ''
          return obj
        })
      }
      // console.log(this.tableData)
    },
    settle() {
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: '请选择条目!',
        });
        return
      }
      let count = 0
      const arr = []
      this.selection.map(v => {
        count += Number(v.infreight)
        arr.push(v.id)
      })
      // console.log(this.selection)
      this.$confirm(`结算金额为${count}元？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.settleReq(arr);
      }).catch(() => { });
    },
    settleReq(delList) {
      let url = `custom/settlement`;
      const params = {
        // userid: this.user.id,
        delList,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    toggleDisplay({ id }) {
      let url = `custom/upsettled`;
      const params = {
        // userid: this.user.id,
        id,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getList(true)
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    this.getFleet()
    this.setQueryParams();
    this.$nextTick(this.getList);
  },
};
</script>

<style lang="less" scoped>
.el-button--success {
  background-color: #13ce66;
  border-color: #13ce66;
}
</style>
